import { makeStyles } from '@material-ui/core/styles';

import { CARD, KICKER, PILL_PRIMARY, PILL_SECONDARY, TEXT_LINK } from '../Home/HomeDashboard/dashboardStyles';
import { REDESIGN_COLORS, REDESIGN_FONTS } from '../../constants';

// Shared look of the admin page: the redesign's cards, pills and kickers, applied
// to dense reporting content (stat tiles, filter bars, tables).

const NARROW = '@media (max-width: 700px)';

const useAdminStyles = makeStyles(() => ({
    intro: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        gap: '16px 24px',
        marginBottom: '22px',
    },
    eyebrowRow: {
        marginBottom: '16px',
    },
    title: {
        margin: '0 0 10px',
        fontSize: 'clamp(1.9rem, 3.6vw, 2.8rem)',
        lineHeight: 1.1,
        letterSpacing: '-0.035em',
        fontWeight: REDESIGN_FONTS.weightHeading,
        color: REDESIGN_COLORS.dark,
    },
    lead: {
        maxWidth: '620px',
        margin: 0,
        color: REDESIGN_COLORS.body,
        fontSize: '1.04rem',
        lineHeight: 1.6,
    },
    roleBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 14px',
        borderRadius: '999px',
        background: REDESIGN_COLORS.mist,
        color: REDESIGN_COLORS.link,
        fontSize: '0.86rem',
        fontWeight: REDESIGN_FONTS.weightHeading,
        whiteSpace: 'nowrap',
    },
    tabs: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
        margin: '0 0 26px',
        padding: 0,
        listStyle: 'none',
    },
    tab: {
        ...PILL_SECONDARY,
        minHeight: '40px',
        padding: '0 18px',
        fontSize: '0.9rem',
    },
    tabActive: {
        ...PILL_PRIMARY,
        minHeight: '40px',
        padding: '0 18px',
        fontSize: '0.9rem',
    },
    // Blocks
    section: {
        marginBottom: '28px',
    },
    kicker: {
        ...KICKER,
        marginBottom: '12px',
    },
    card: {
        ...CARD,
        padding: '22px 24px',
        [NARROW]: {
            padding: '16px',
        },
    },
    cardTitle: {
        margin: '0 0 14px',
        fontSize: '1.05rem',
        fontWeight: REDESIGN_FONTS.weightHeading,
        color: REDESIGN_COLORS.dark,
    },
    tileGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 180px), 1fr))',
        gap: '14px',
    },
    stateCard: {
        ...CARD,
        padding: '26px 28px',
        color: REDESIGN_COLORS.body,
        fontSize: '0.98rem',
        lineHeight: 1.6,
    },
    stateCardWarn: {
        background: REDESIGN_COLORS.amberSurface,
        borderColor: REDESIGN_COLORS.amberBorder,
    },
    // Filter bars above the tables
    filters: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '12px 16px',
        marginBottom: '16px',
    },
    filterControl: {
        minWidth: '160px',
    },
    filterSearch: {
        minWidth: '240px',
        flex: '1 1 240px',
    },
    pills: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px',
        marginBottom: '16px',
    },
    pill: {
        ...PILL_SECONDARY,
        minHeight: '34px',
        padding: '0 14px',
        fontSize: '0.84rem',
    },
    pillActive: {
        ...PILL_PRIMARY,
        minHeight: '34px',
        padding: '0 14px',
        fontSize: '0.84rem',
        boxShadow: 'none',
    },
    // Misc
    mono: {
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
        fontSize: '0.82rem',
        wordBreak: 'break-all',
    },
    muted: {
        color: REDESIGN_COLORS.muted,
    },
    link: TEXT_LINK,
    userCell: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        minWidth: 0,
    },
    userCellText: {
        minWidth: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    avatarSmall: {
        width: '28px',
        height: '28px',
    },
    nowrap: {
        whiteSpace: 'nowrap',
    },
}));

export default useAdminStyles;
